import {RepositoryFactory} from '@/api/factory/repositoryFactory'
const CartLink = RepositoryFactory.get('cartLink')
const namespaced = true

const state = {
  cartLink: {},
  cartLinks: [],
  reportCartLinks: [],
  countReport: 0,
  count: 0,
  products: [],
}

const actions = {
  async createCartLink(_, data) {
    const res = await CartLink.create(data)
    return res.data
  },
  async fetchCartLinks({commit}, params = {}) {
    const res = await CartLink.fetch({
      ...params,
      _sort: 'expiredDate:desc',
    })
    commit('setCartLinks', res.data || [])
    return res.data
  },
  async fetchCartLink({commit}, id) {
    const res = await CartLink.fetchOne(id)
    commit('setCartLink', res.data)
    return res.data
  },
  async countCartLink({commit}, params = {}) {
    const res = await CartLink.count({...params})
    commit('setCount', res.data || 0)
    return res.data || 0
  },
  async updateCartLink({commit}, {id, ...params}) {
    const res = await CartLink.update(id, params)
    commit('setCartLink', res.data)
    return res.data
  },
  async removeCartLink(_, id) {
    const res = await CartLink.remove(id)
    return res.data
  },
  async fetchReportCartLinks({commit}, params = {}) {
    const res = await CartLink.fetchUserCartLink({
      ...params,
    })
    commit('setReportCartLink', res.data || [])
    return res.data
  },
  async countReportCartLink({commit}, params = {}) {
    const res = await CartLink.countUserCartLink({...params})
    commit('setCountReportCartLink', res.data || 0)
  },
}

const mutations = {
  setCount(state, count) {
    return (state.count = count)
  },
  setCountReportCartLink(state, count) {
    return (state.countReport = count)
  },
  setCartLink(state, blog) {
    return (state.cartLink = blog)
  },
  setReportCartLink(state, value) {
    return (state.reportCartLinks = value)
  },
  setCartLinks(state, blogs) {
    return (state.cartLinks = blogs)
  },
  setProducts(state, products) {
    state.products = products
  },
}

const getters = {
  getList: state => {
    return state.cartLinks
  },
  getCount: state => {
    return state.count
  },
  getOne: state => {
    return state.cartLink
  },
  getProducts: state => {
    return state.products
  },
}

export default {
  namespaced,
  state,
  actions,
  mutations,
  getters,
}
